function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.32 8.571v27.03l-1.396 1.394H7.134c-.549-.544-.852-.85-1.397-1.393V3.77c.545-.544.848-.85 1.396-1.393H26.11l6.21 6.193z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#file_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.037.679H34.02v38.014H4.037V.68z",
  fill: "#FFCE32"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.318 19.765v15.704l-1.4 1.384H15.053l17.266-17.088z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#file_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.349 18.075H34.02v20.468H13.35V18.075z",
  fill: "#D8B87A"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.317 8.544h-6.262V2.377l6.262 6.167z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#file_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.34.686h9.692v9.55H24.34V.686z",
  fill: "#F8FBCF"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.706 13.15v2.042H11.882V13.15h15.824zM27.706 16.384v2.043H11.882v-2.043h15.824zM27.706 19.618v2.043H11.882v-2.043h15.824zM27.706 22.852v2.043H11.882v-2.043h15.824zM27.706 26.087v2.043H11.882v-2.043h15.824z",
  fill: "#003035"
});

const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "file_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 2,
  width: 28,
  height: 35
}, _ref), _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "file_svg__b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 15,
  y: 19,
  width: 18,
  height: 18
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "file_svg__c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 26,
  y: 2,
  width: 7,
  height: 7
}, _ref5), _ref6, _ref7);

export default SvgFile;